export default "__VITE_ASSET__CA5z5JdQ__"